import React from 'react';
import {
  Container, Row, Col,
} from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import SafeLink from './components/SafeLink';
import Profile from './components/Profile';
import ProjectGallery from './components/ProjectGallery';
import RandomFact from './components/RandomFact';

import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {

  return (
    <Container fluid className={"d-flex justify-content-center"}>
      <Row  style={{maxWidth: 1024}}>

        <Col xs={{span: 12}} >
          <Row className="mt-3">
            {/* <Headline></Headline> */}

            <Col xs={{span: 12}} lg={4}>
              <Profile size={240} margin={{top: 20, bottom: 10, left: 15, right: 15}}></Profile>
            </Col>
            <Col xs={{span: 12}} lg={8}>
              <h1>
                Younghoon Kim
              </h1>
              <p>Hi! I'm a Software Engineer in <SafeLink url="https://databricks.com/">Databricks Visualization Team.</SafeLink></p>
              <p> I got my Ph.D. degree at the <SafeLink url="https://www.cs.washington.edu/" >Paul G. Allen School of Computer Science & Engineering</SafeLink>, University of Washington. My advisor was <SafeLink url="http://jheer.org/" >Prof. Jeffrey Heer</SafeLink>, and I was a member of the <SafeLink url="https://idl.cs.washington.edu/" >UW Interacitve Data Lab</SafeLink>. 
              </p>
              <p>
              My Ph.D. work is to bring the perception of the data visualization to the automation of the visualization design. I'm interested in the algorithms / models / systems for automatic visualization desgins, and perception studies across single / multiple / sequences of statistical graphics.
              </p>
              <p>
                I received my B.S. from the Seoul National University in 2015 and my Masters from the University of Washington in 2017. I worked at MSR and Apple as a summer intenship. More details in my CV.
              </p>
            </Col>
          </Row>
          <Row>
            <Col>
              <SafeLink url="mailto:yhoonkim01 at gmail.com" target="_blank" rel="noopener noreferrer" className="mr-3">
                <Icon.Envelope size={25}/> yhoonkim01 at gmail dot com
              </SafeLink>
              <SafeLink url="https://docs.google.com/document/d/1uVz1Wb7rzEpjCJYMPv8ZDdhYDJ18JTtt1Rp7RyDDo0U/edit?usp=sharing" target="_blank" rel="noopener noreferrer" className="mr-3">
                <Icon.FileText size={25}/> CV
              </SafeLink>
              <SafeLink url="https://drive.google.com/open?id=1xLHxoEKsQs5oBE9EZlob6BSFMJ3ZeBOs" target="_blank" rel="noopener noreferrer">
                <Icon.FileRichtext size={25}/> Research Statement
              </SafeLink>
            </Col>
          </Row>
          <Row className="mt-3">

            <Col>
              <h4>Papers</h4>
              <ProjectGallery/>
            </Col>
          </Row>
          <Row className="mt-3 mb-3">

            <Col>
              <h4>Random Fact</h4>
              <RandomFact/>
            </Col>
          </Row>

        </Col>
      </Row>
    </Container>
  );
}

export default App;
